import DashboardLayout from "@/layouts/dashboard-layout";
import ActivityCard from "./activity-card";
import "./styles.scss";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { useAuth } from "@/contexts/auth-context";
import { activityLevelFetch } from "@/redux/slice/activity/levels";
import { Activity } from "@/types/activity";
import { useLanguageContext } from "@/contexts/language-context";

export function Activties() {
  const { token } = useAuth();
  const dispatch = useAppDispatch();
  const { values } = useLanguageContext();

  const { data, loading } = useAppSelector((state) => state.activityLevel);

  useEffect(() => {
    if (token) {
      dispatch(activityLevelFetch({ token, language: values.initialLanguage }));
    }
  }, [dispatch, token, values.initialLanguage]);
  const mainData = data ?? [];

  return (
    <DashboardLayout>
      {loading ? (
        <p>loading</p>
      ) : (
        <div>
          {mainData.length < 1 ? (
            <p>
              {values.initialLanguage
                ? `${values.initialLanguage} is in development - our team is actively building lessons to make it ready for learning soon`
                : "Please, Select a language"}
            </p>
          ) : (
            mainData.map((activity: Activity, index: number) => (
              <ActivityCard
                key={index}
                activity={activity}
                length={data?.length}
              />
            ))
          )}
        </div>
      )}
    </DashboardLayout>
  );
}
